export const fonts = {
  GilroyBold: 'GilroyBold',
  GilroyExtraBold: 'GilroyExtraBold',
  GilroyLight: 'GilroyLight',
  GilroyRegular: 'GilroyRegular',
  GilroySemiBold: 'GilroySemiBold',
  OpenSans: 'Open Sans',
};
